module.exports = __webpack_public_path__ + "static/img/logo.5213a3d7.png";